import Vue from 'vue';
import ApiUrl from '../apiurl';
export default {
    namespaced: true,
    state: {
        newsList: [],
        newCardsPieList: [],
        chartList: [],
        lastData: [],
        n4q: null,
        lockReq: false
    },
    getters: {
        lockReq: (state) => {
            return state.lockReq;
        },
        n4q: (state) => {
            return state.n4q;
        },
        newsList: (state) => {
            return state.newsList;
        },
        newCardsPieList: (state) => {
            return state.newCardsPieList;
        },
        chartList: (state) => {
            return state.chartList;
        },
        lastData: (state) => {
            return state.lastData;
        },
        getChartByName: (state) => {
           
            return function(name) {
              //  alert(name);
                for (var x of state.chartList) {
                    if (x.name == name) {
                        return x;
                    }
                }
                return null;
            }
        },
    },

    mutations: {
        setNewsList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'newsList', [...newValue]);
            }
        },
        setNewCardsPieList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'newCardsPieList', [...newValue]);
            }
        },
        setChartList(state, newValue) {

            if (Array.isArray(newValue)) {
                Vue.set(state, 'chartList', [...newValue]);
            }
        },
        setLastData(state, newValue) {

            if (Array.isArray(newValue)) {
                Vue.set(state, 'lastData', [...newValue]);
            }
        },
        setN4q(state, newValue) {
            Vue.set(state, 'n4q', newValue);
        },
        setLockReq(state, newValue) {
            Vue.set(state, 'lockReq', newValue);
        },
    },

    actions: {

        async getN4q({ commit, state, dispatch }, { handle }) {

            try {
                commit('startIndexLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.chart.qn4q);
                if (rsp && rsp.data) {
                    commit('setN4q', rsp.data);
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },
        async getLastData({ commit, state, dispatch }, { handle }) {

            try {
                commit('startIndexLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.chart.lastdata);
                if (rsp && rsp.data) {
                    commit('setLastData', rsp.data);
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },
        async getChartList({ state, dispatch }, { handle }) {
         //alert('getChartList');
            const sleep = (milliseconds) => {
                return new Promise(resolve => setTimeout(resolve, milliseconds))
            };

            while (state.lockReq) {
                console.log("wait...");
                await sleep(1);
            }
            if (state.chartList != null && state.chartList.length > 0) {
                handle && handle(state.chartList);
            } else {


                dispatch('queryChartConfigs', { handle: handle });

            }
        },
        async queryChartUpdate({ commit }, { params, handle }) {
            try {
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.put(ApiUrl.chart.update, params);
                if (rsp && rsp.data) {
                    //commit('保存数据?', rsp.data); 
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },
        async queryChartBuild({ commit }, { params, handle }) {

            try {
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.chart.build, params);
                if (rsp && rsp.data) {
                    //commit('保存数据?', rsp.data); 
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, { root: true });
            }
        },
        async queryChartData({ commit }, { params, handle }) {
            
            try {
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.chart.data, params);
                if (rsp && rsp.data) {
                    //commit('保存数据?', rsp.data); 
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },
        async queryChartConfigs({ commit }, { handle }) {
            try {
               // commit('setLockReq', true);
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.chart.list);
                if (rsp && rsp.data) {
                    commit('setChartList', rsp.data);
                    commit('setLockReq', false);
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },
        async queryDailyNewsList({
            commit
        }, {
            cb
        }) {
            try {
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.home.dailynews);
                if (rsp && rsp.data) {
                    commit('setNewsList', rsp.data);
                    cb && cb(true);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },

        async queryNewCardsPieList({ commit }, { cb }) {
            try {
                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.home.newcarpie);
                if (rsp && rsp.data) {
                    commit('setNewCardsPieList', rsp.data);
                    cb && cb(true);

                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }
        },

        async queryNewCarIds({ commit }, { params, cb }) {
            try {


                commit('startIndexLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.chart.queryNewCarIds, params);
                if (rsp && rsp.data) {
                    cb && cb(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopIndexLoading', null, {
                    root: true
                });
            }

        }

    }

}